import { queryKeys } from 'config/queryKeys'
import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'react-i18next'
import { useAxiosPrivate, useToast } from 'shared/hooks'

type UseRequestPayoutMutationProps = {
	userId: number | null
	closePayoutModal: () => void
}

export const useRequestPayoutMutation = ({
	userId,
	closePayoutModal
}: UseRequestPayoutMutationProps) => {
	const axiosPrivate = useAxiosPrivate()
	const { t } = useTranslation()
	const queryClient = useQueryClient()

	const { mutate: requestPayoutMutation } = useMutation({
		mutationFn: () => {
			// TODO: change to apiRoutes
			return axiosPrivate.post('/accounts/prepare_payout/', { ids: [userId] })
		},
		onSuccess: () => {
			useToast({
				type: 'success',
				message: t('Payout request succeeded')
			})()

			queryClient.invalidateQueries({ queryKey: queryKeys.users.all })
		},
		onError: () => {
			useToast({
				type: 'error',
				message: t('Something went wrong')
			})()
		},
		onSettled: () => {
			closePayoutModal()
		}
	})

	return {
		requestPayoutMutation
	}
}
